"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.responseHandler = exports.responseHandlerWithoutSuccess = exports.catchErrorHandler = exports.buildSettings = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ajax = require("rxjs/ajax");

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _handleError = require("./handleError");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Settings structure follows https://github.com/Reactive-Extensions/RxJS-DOM/blob/master/doc/operators/ajax.md
var buildSettings = function buildSettings(_ref) {
  var token = _ref.token,
      settings = _ref.settings;
  return _objectSpread(_objectSpread({
    withCredentials: settings.withCredentials,
    crossDomain: true
  }, settings || {}), {}, {
    headers: _objectSpread(_objectSpread({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }, token ? {
      Authorization: "Bearer ".concat(token)
    } : {}), settings && settings.headers || {})
  });
};

exports.buildSettings = buildSettings;

var catchErrorHandler = function catchErrorHandler(payload) {
  var _payload$name = payload.name,
      name = _payload$name === void 0 ? '' : _payload$name,
      status = payload.status,
      response = payload.response;

  if (status === 403) {
    window.location.href = '/teams';
  }

  return (0, _rxjs.throwError)(_objectSpread({
    name: name,
    status: status
  }, response));
};

exports.catchErrorHandler = catchErrorHandler;
var responseHandlerWithoutSuccess = [(0, _operators.mergeMap)(function (_ref2) {
  var response = _ref2.response;
  return (0, _rxjs.of)(response);
}), (0, _operators.catchError)(catchErrorHandler)];
exports.responseHandlerWithoutSuccess = responseHandlerWithoutSuccess;
var responseHandler = [(0, _operators.mergeMap)(function (payload) {
  var response = payload.response;

  if (response.success) {
    return (0, _rxjs.of)(response);
  }

  return (0, _rxjs.throwError)(payload);
}), (0, _operators.catchError)(catchErrorHandler)];
exports.responseHandler = responseHandler;

/**
 * Api service factory function.
 *
 * @param {object} params - Api service config.
 * @param {string} params.baseUrl - Base application url.
 * @param {TokenService} params.tokenService - Get token value to apply it for request.
 * @param {OperatorFunction<AjaxResponse, any>[]} [params.successResponseHandler=undefined] - If exist apply special success handlers.
 * @param {boolean} [params.defaultWithoutSuccess=false] - Param for using without success handler by default.
 * @param {boolean} [params.withCredentials] -  Param for using withCredentials for queries - can be override per query.
 * @returns {IApiService} Return Api service object.
 * @example
 * Service with default request handlers
 * const apiService = createApiService({ tokenService });
 *
 * If you have some custom logic for responses you should provide additional param
 *
 * const successResponseHandler = [
 * mergeMap(({ response, status }) => {
 * if (status === 300 && window.location.href !== response.redirectUrl) {
 * window.location.href = response.redirectUrl;
 * }
 * return of(response);
 * }),
 * catchError(catchErrorHandler),
 * ];
 *
 * const apiService = createApiService({ baseUrl: '...', tokenService, successResponseHandler, withCredentials });
 *
 * After creating you should put it to the epic middleware factory function
 * const epicMiddleware = createEpicMiddleware({
 * dependencies: {
 * apiService,
 * ... another services
 * },
 * });
 */
var createApiService = function createApiService(_ref3) {
  var baseUrl = _ref3.baseUrl,
      tokenService = _ref3.tokenService,
      successResponseHandler = _ref3.successResponseHandler,
      _ref3$defaultWithoutS = _ref3.defaultWithoutSuccess,
      defaultWithoutSuccess = _ref3$defaultWithoutS === void 0 ? false : _ref3$defaultWithoutS,
      _ref3$withCredentials = _ref3.withCredentials,
      withCredentials = _ref3$withCredentials === void 0 ? true : _ref3$withCredentials;

  var getRequest = function getRequest(url, method, settings) {
    var token = tokenService.getToken();
    return (0, _ajax.ajax)(_objectSpread({
      url: "".concat(baseUrl).concat(url),
      method: method
    }, buildSettings({
      token: token,
      settings: _objectSpread({
        withCredentials: withCredentials
      }, settings)
    })));
  };

  var getSuccessResponseHandler = function getSuccessResponseHandler(withoutSuccess) {
    if (successResponseHandler) {
      return successResponseHandler;
    }

    return withoutSuccess ? responseHandlerWithoutSuccess : responseHandler;
  };

  return {
    handleError: _handleError.handleError,
    handlers: _handleError.handlers,
    get: function get(url, settings) {
      var withoutSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultWithoutSuccess;
      var request = getRequest(url, 'GET', settings);
      var handler = getSuccessResponseHandler(withoutSuccess);
      return request.pipe.apply(request, (0, _toConsumableArray2["default"])(handler));
    },
    post: function post(url, settings) {
      var withoutSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultWithoutSuccess;
      var request = getRequest(url, 'POST', settings);
      var handler = getSuccessResponseHandler(withoutSuccess);
      return request.pipe.apply(request, (0, _toConsumableArray2["default"])(handler));
    },
    put: function put(url, settings) {
      var withoutSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultWithoutSuccess;
      var request = getRequest(url, 'PUT', settings);
      var handler = getSuccessResponseHandler(withoutSuccess);
      return request.pipe.apply(request, (0, _toConsumableArray2["default"])(handler));
    },
    patch: function patch(url, settings) {
      var withoutSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultWithoutSuccess;
      var request = getRequest(url, 'PATCH', settings);
      var handler = getSuccessResponseHandler(withoutSuccess);
      return request.pipe.apply(request, (0, _toConsumableArray2["default"])(handler));
    },
    "delete": function _delete(url, settings) {
      var withoutSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultWithoutSuccess;
      var request = getRequest(url, 'DELETE', settings);
      var handler = getSuccessResponseHandler(withoutSuccess);
      return request.pipe.apply(request, (0, _toConsumableArray2["default"])(handler));
    },
    getFile: function getFile(url) {
      var settings = {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      return getRequest(url, 'GET', settings).pipe((0, _operators.map)(function (response) {
        return response.response;
      }));
    },
    postFile: function postFile(url, settings) {
      var _ref4;

      var withoutSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultWithoutSuccess;
      var token = tokenService.getToken();
      var builtSettings = buildSettings({
        token: token,
        settings: _objectSpread({
          withCredentials: withCredentials
        }, settings)
      });
      delete builtSettings.headers['Content-Type'];
      var request = (0, _ajax.ajax)(_objectSpread({
        url: "".concat(baseUrl).concat(url),
        method: 'POST'
      }, builtSettings));
      var handler = getSuccessResponseHandler(withoutSuccess);
      return (_ref4 = request).pipe.apply(_ref4, (0, _toConsumableArray2["default"])(handler));
    },
    refreshToken: function refreshToken(url, settings) {
      var _getRequest;

      return (_getRequest = getRequest(url, 'POST', settings)).pipe.apply(_getRequest, responseHandlerWithoutSuccess);
    }
  };
};

var _default = createApiService;
exports["default"] = _default;